import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const paymentAlertWrapperStyle = css`
  display: grid;
  grid-template-columns: max-content auto max-content;
  column-gap: 8px;
  align-items: center;
  padding: 8px;
  background-color: #fffaf0;
  border: 1px solid #d69e2e;
  border-radius: 4px;

  ${MEDIA_QUERY_FOR_SP} {
    grid-template-columns: max-content auto;
    grid-template-rows: auto auto;
  }
`;

export const paymentAlertIconStyle = css`
  min-height: 24px;
`;

export const paymentAlertTextStyle = css`
  color: #975a16;
  font-size: 14px;
  line-height: 1.4em;
`;

export const paymentAlertTextBoldStyle = css`
  font-weight: bold;
`;

export const paymentAlertContentStyle = css`
  display: grid;
  grid-template-columns: 1fr;
  color: #975a16;
  font-size: 14px;

  ${MEDIA_QUERY_FOR_PC} {
    grid-template-columns: max-content max-content;
    column-gap: 8px;
  }
`;

export const continuePaymentButtonStyle = css`
  /* 6em: ボタンテキスト幅、20px: padding左右合計(10px * 2) */
  min-width: calc(6em + 20px);
  padding: 6px 10px;
  color: #fff;
  font-size: 14px;
  background-color: #975a16;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  ${MEDIA_QUERY_FOR_SP} {
    grid-column: 1 / -1;
    justify-self: end;
    margin-top: 8px;
  }
`;
